import script from "./_CvSvg.vue?vue&type=script&lang=js"
export * from "./_CvSvg.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__